import { RouterEffects } from './router.effect';

export const effects: any[] = [RouterEffects];

export * from './router.effect';



// WEBPACK FOOTER //
// E:/NeoSME/1.Full Project Spekwo/pro/prodash/src/app/store/effects/index.ts